import React from 'react'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

export default function Notifications() {
  const { t } = useLang()
  const n = t.acct.notifs

  const ITEMS = [
    { when: n.just_now,   title: n.visit_confirmed,   body: n.visit_confirmed_body,  kind: 'visit' },
    { when: n.ago_2h,     title: n.filter_low,         body: n.filter_low_body,       kind: 'maintenance' },
    { when: n.yesterday,  title: n.photos_uploaded,    body: n.photos_uploaded_body,  kind: 'docs' },
    { when: n.ago_apr14,  title: n.receipt_available,  body: n.receipt_available_body, kind: 'docs' },
    { when: n.ago_apr9,   title: n.membership_renewed, body: n.membership_renewed_body, kind: 'billing' },
  ]

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.notifs]} />
        <div className="content">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 24 }}>
            <div>
              <div className="kicker accent" style={{ marginBottom: 10 }}>{n.eyebrow}</div>
              <h1 className="h-display" style={{ fontSize: 36, margin: 0 }}>
                {n.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{n.title_2_word}</span>
              </h1>
            </div>
            <button className="btn" style={{ padding: "8px 14px" }}>{n.mark_all_read}</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {ITEMS.map((it, i) => (
              <div key={i} className="tile" style={{ padding: 18, background: "var(--paper)", display: "grid", gridTemplateColumns: "auto 1fr auto", gap: 16, alignItems: "start" }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: "rgba(194,85,45,0.12)", color: "var(--terracotta)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}>●</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 4 }}>{it.title}</div>
                  <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.45 }}>{it.body}</div>
                </div>
                <div className="font-mono" style={{ fontSize: 11, color: "var(--muted)", whiteSpace: "nowrap" }}>{it.when}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
